import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReceiveDetail, applyOtherMaterialReceive } from '../api/index.js';
import MaterialSelectDrawer from './materialSelectDrawer.vue';
export default {
  name: 'MaterialReceiveApplyDrawer',
  components: {
    MaterialSelectDrawer: MaterialSelectDrawer
  },
  data: function data() {
    return {
      submitLoading: false,
      loading: false,
      drawerSelect: false,
      excludedIds: [],
      form: {
        user_name: '',
        date: '',
        remark: '',
        material_items: []
      }
    };
  },
  created: function created() {
    this.loadDetail();
  },
  methods: {
    loadDetail: function loadDetail() {
      var _this = this;
      getOtherMaterialReceiveDetail().then(function (res) {
        var info = res.data && res.data.user_info ? res.data.user_info : {};
        var list = res.data && res.data.list || [];
        _this.form.user_name = info.user_name;
        _this.form.date = info.date || '';
        _this.form.remark = info.remark || '';
        _this.form.material_items = list;
      }).catch(function () {
        _this.$message.error('详情加载失败');
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this2.form.material_items.length === 0) {
          _this2.$message.warning('请至少添加一个物料');
          return;
        }
        _this2.submitLoading = true;
        var params = {
          date: _this2.form.date,
          remark: _this2.form.remark,
          material_items: _this2.form.material_items.map(function (item) {
            return {
              material_stock_id: item.material_stock_id,
              id: item.id,
              num: Number(item.num)
            };
          })
        };
        applyOtherMaterialReceive(params).then(function () {
          _this2.$message.success('领用申请已提交');
          _this2.$emit('emitGetList');
        }).catch(function (err) {
          _this2.$message.error(err && err.message || '提交失败');
        }).finally(function () {
          _this2.submitLoading = false;
        });
      });
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleAddMaterial: function handleAddMaterial() {
      this.excludedIds = (this.form.material_items || []).map(function (item) {
        return item.id;
      }).filter(Boolean);
      this.drawerSelect = true;
    },
    handleMaterialSelected: function handleMaterialSelected(materials) {
      var _this3 = this;
      // 追加而非替换：按 id 去重（同一物料编码在不同仓库是不同记录），过滤后追加到明细列表尾部
      var list = (materials || []).filter(function (item) {
        return !_this3.form.material_items.some(function (m) {
          return m.id === item.id;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          num: ''
        });
      });
      this.form.material_items = [].concat(_toConsumableArray(this.form.material_items), _toConsumableArray(list));
      this.drawerSelect = false;
    },
    handleRemove: function handleRemove(index) {
      this.form.material_items.splice(index, 1);
    }
  }
};